import { render, staticRenderFns } from "./nav-bookmarks.vue?vue&type=template&id=4afc2fd2&scoped=true&"
import script from "./nav-bookmarks.vue?vue&type=script&lang=js&"
export * from "./nav-bookmarks.vue?vue&type=script&lang=js&"
import style0 from "./nav-bookmarks.vue?vue&type=style&index=0&id=4afc2fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afc2fd2",
  null
  
)

export default component.exports